import React from 'react';
import { ProgressRing } from '../providers/harmony-scope/lazy-enablers';
import { isStandalone } from '../utils/utils-standalone';
import { useMEMTranslation } from '../utils/text-utils';

interface IProps {
  isLoading: boolean;
  includeStandaloneHeader?: boolean;
}

export const LoadingPlaceholder = (props: React.PropsWithChildren<IProps>) => {
  const { isLoading, children, includeStandaloneHeader } = props;
  const { t } = useMEMTranslation();
  const standalone = isStandalone();

  return isLoading ? (
    <>
      {includeStandaloneHeader && standalone && <h1 style={{ fontSize: '1px' }}>{t('standaloneLoadingPlaceholder')}</h1>}
      <ProgressRing indeterminate style={{ margin: '50%' }} />
    </>
  ) : (
    <>{children as React.ReactElement<any>}</>
  );
};
